import React, { useEffect } from "react";
import NetwalaModal from "../Items/Modal/Index";
import { Col, Row, Form, Input } from "antd";
import "./styles/RequestIPTVModal.css";
import NetwalaButton from "../Items/Button/Index";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
const UpdateAreaModal: React.FC<UpdateAreaModal> = ({
  show,
  handleClose,
  area,
  label,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<updateAreaApiProp>("areas/updateAreaDetails", true);

  const onFinish = (values: any) => {
    const { areaName } = values;
    postApiData({ areaName: areaName.trim(), areaId: area.intPkAreaID });
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {};

  return (
    <>
      <NetwalaModal
        title={`Update ${label}`}
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => handleClose(false)}
      >
        {contextHolder}

        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="updateAreaForm"
              initialValues={{ areaName: area.areaName }}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">{label} Name</span>
                }
                name="areaName"
                rules={[
                  {
                    required: true,
                    message: `Please Enter ${label} Name`,
                  },
                  {
                    min: 5,
                    message: `${label} Name Should be more than 5 characters`,
                  },
                  {
                    pattern: /^[a-zA-Z0-9\s\-_.]+$/,
                    message: `${label} Name can only contain letters, numbers, spaces, hyphens (-), underscores (_), and periods (.)`,
                  },
                  {
                    whitespace: true,
                    message: `${label} Name cannot be empty or contain only spaces`,
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Gulberg 1"
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text={`Update ${label}`}
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default UpdateAreaModal;
